import { render, staticRenderFns } from "./AppAccordion.vue?vue&type=template&id=ddb5a416&"
import script from "./AppAccordion.vue?vue&type=script&lang=js&"
export * from "./AppAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports